// dome

export default [
  // dome
  {
    path: '/dome',
    name: 'Dome',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/dome')
  },
  // DomePage
  {
    path: '/DomePage',
    name: 'DomePage',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/DomePage')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/dome.js